import { render, staticRenderFns } from "./conversationNew.vue?vue&type=template&id=70d303a5&"
import script from "./conversationNew.vue?vue&type=script&lang=js&"
export * from "./conversationNew.vue?vue&type=script&lang=js&"
import style0 from "./conversationNew.vue?vue&type=style&index=0&id=70d303a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports